import ColorPicker from 'react-pick-color';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import './ColorPicker.css';

import { anyType } from '../../types';
import { ColorPickerProps } from '../../types/components/colorPicker';

const MapColorPicker: React.FC<ColorPickerProps> = (props) => {
    const { setColor, color } = props;

    return (
        <div className='colorpiker-conteiner'>
            <ColorPicker color={color} onChange={(color: anyType) => setColor(color.rgb)} />
        </div>
    );
};

export default MapColorPicker;
